import Vue from 'vue';
const state = {
    token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIyIiwianRpIjoiMzk0OWZjMWZlYTdlYTEwZDRjMTQ2MGM5YTMzNjY4ZjJjZWE1YWMyYjFiYjY2ZDY0YjFjMDJkYjFiZGNjMTY3NzYyYzJhN2ExYzRmZDIxMmUiLCJpYXQiOjE2MDE2NDA2NTIsIm5iZiI6MTYwMTY0MDY1MiwiZXhwIjoxNjMzMTc2NjUyLCJzdWIiOiIyIiwic2NvcGVzIjpbXX0.jmXzxRf9HnJnLg1lIP4WwlX3STxOgNJGi-JREP8UKQ-0gGKYc9uVgvrYF5hCFQ1-wW0u3BWT4u9I9fK9luUgMDr7m2o95KUoj1EoopwiWBg5Y7TraXAHr9HVIUdavIumQuR83fycoGxft1GGWYSDU5rrvWrneL_uhTJ3iwHvJ1ULlgPncgu0qLKoOj4juSBtIT4OeEZoE6BfxORr4TiAOiQBLFWBHaki8KJzHNEAPaudaJAsG80Sh1ioReUaPT96qTcoMe1Z7gVBO15jfTgTGyJVvLjuYejVyuyK_S4syil6l_IZJWKjKPHIy1fSiFggO87SEbI8hvWgNAIFtYrBIfwO4Xsw1XDXGSqqZLJIIPdz8ta4Ongxe50X3pbKCOP_cd9fKG3XGlohpdidHRL0PgXybWsIuxFyJ6Dj80lsZDcY1eRIREOrVe1eaBoOzBW8lge3qz82nQRSaDi2iLCf3URQihknfsChMh6nd3v5dtdiU5gKSpqKT3r5A7A9bwR55XXBeF7vlOP7x3qVn993LexaPzm7iRtudNXFC7bjopULLnB8U4lUvpixl__6EQNMd_NRxBtlU-jc6GYD91dmm4ZVxSMiGGPB3Y7UAZczikQ4uPXzjBH-tueWvE_evaj1ubhcURVAOgqyamrN_UQkfRNH4Ne8DwCFpcSUDOTmMQA',
    commande: {},
    categorie: {},
    lastOrder: {},
    fileUploading: false,
    percentUploaded: 0,
};

const getters = {
    commande: state => state.commande,
    categorie: state => state.categorie,
    lastOrder: state => state.lastOrder,
    fileUploading: state => state.fileUploading,
    percentUploaded: state => state.percentUploaded
};

const actions = {

    getCategorie({
        commit
    }, catId) {
        return new Promise((resolve, reject) => {
            window.axios.get('/api/categories/' + catId).then(response => {
                commit('setCategorie', response.data);
                resolve(response);
            }).catch(error => {

            });
        });
    },

    getLastOrder({commit},param) {
        return new Promise((resolve, reject) => {
            window.axios.get('/api/lastOrder', {params: {catId:param.catId,sousCatId:param.sousCatId}}).then(response => {
                commit('setLastOrder', response.data);
                resolve(response);
            });
        });
    },

    uploadFiles({
        commit
    }, files) {
        commit('setFileUploading', true)
        commit('setPercentUploaded', 0)
        const onUploadProgress = (progressEvent) => {
            const { loaded, total } = progressEvent;
            let percent = Math.floor((loaded * 100) / total);
            commit('setPercentUploaded', percent)
        };

        return new Promise((resolve, reject) => {
            window.axios.post('/api/upload-files', files, {onUploadProgress}).then(response => {
                commit('setFileUploading', false)
                resolve(response);
            }).catch(error => {
                Vue.toasted.global.expedium_error({
                    message : 'Une erreur est survenue. Si le problème persiste veuillez contacter nos services de 8h à 18h du lundi au vendredi. (code erreur : '+error.response.data.message+')'
                });
                commit('setFileUploading', false)
            });
        });
    },

    extractDestinataires({
        commit, state
    }, filepath) {
        commit('setFileUploading', true)
        return new Promise((resolve, reject) => {
            window.axios.post('/api/extractDestinataires', {filename : filepath, electronique: state.categorie.id === 4}).then(response => {
                commit('setFileUploading', false)
                resolve(response);
            }).catch(error => {
                let message = ""
                if(error.response.data.errors){
                    error.response.data.errors.forEach(e => {
                       message += "<BR/>" + e 
                    })
                }             
                Vue.toasted.global.expedium_info({
                    message : message+'<BR/>La liste des destinataires n\'a pas pu être traitée. Veuillez ajouter le fichier dans un des dossiers, nous la traiterons manuellement.<BR/><BR/>'
                });
                commit('setFileUploading', false)
                reject(error)
            });
        });
    },

    updateCommande({
        commit
    }, commande) {
        return new Promise((resolve, reject) => {
            window.axios.put('/api/commandes/'+commande.id, commande).then(response => {
                commit('setFileUploading', false)
                resolve(response);
            }).catch(error => {
                let message = 'Erreur lors de l\'envoi: '+error.response.data.message+' erreur: '+error.response.status;
                if(Array.isArray(error.response.data.errors)) {
                    message = "Erreur de validation<BR/>";
                    error.response.data.errors.forEach(err => {
                        message += "<BR/>"+err;
                    })
                }
                Vue.toasted.global.expedium_error({
                    message : message
                });
                commit('setFileUploading', false)
            });
        });
    },

    sendCommande({
        commit
    }, commande) {
        commit('setFileUploading', true)
        return new Promise((resolve, reject) => {
            window.axios.put('/api/send/'+commande.id, commande).then(response => {
                commit('setFileUploading', false)
                resolve(response);
            }).catch(error => {
                let message = 'Erreur lors de l\'envoi: '+error.response.data.message+' erreur: '+error.response.status;
                if(Array.isArray(error.response.data.errors)) {
                    message = "Erreur de validation<BR/>";
                    error.response.data.errors.forEach(err => {
                        message += "<BR/>"+err;
                    })
                }
                Vue.toasted.global.expedium_error({
                    message : message
                });
                commit('setFileUploading', false)
            });
        });
    },

    sendEmails({commit}, commande) {
        return new Promise((resolve, reject) => {
            window.axios.put('/api/sendEmails/'+commande.id, commande).then(response => {
                resolve(response);
            }).catch(error => {
                let message = 'Erreur lors de l\'envoi: '+error.response.data.message+' erreur: '+error.response.status;
                if(Array.isArray(error.response.data.errors)) {
                    message = "Erreur de validation<BR/>";
                    error.response.data.errors.forEach(err => {
                        message += "<BR/>"+err;
                    })
                }
                Vue.toasted.global.expedium_error({
                    message : message
                });
                commit('setFileUploading', false)
            });
        });
    },

    createCommande({
        commit
    }, commande) {
        commit('setFileUploading', true)
        return new Promise((resolve, reject) => {
            window.axios.post('/api/commandes', commande).then(response => {
                commit('setFileUploading', false)
                resolve(response);
            }).catch(error => {
                Vue.toasted.global.expedium_error({
                    message : 'Une erreur est survenue. Si le problème persiste veuillez contacter nos services de 8h à 18h du lundi au vendredi. (code erreur : '+error.response.data.message+')'
                });
                commit('setFileUploading', false)
                reject(error);
            });
        });
    },

    createCommandeUnitaire({
        commit
    }, commande) {
        return new Promise((resolve, reject) => {
            window.axios.post('/api/commandeunitaire', commande).then(response => {
                resolve(response);
            }).catch(error => {
                Vue.toasted.global.expedium_error({
                    message : 'Une erreur est survenue. Si le problème persiste veuillez contacter nos services de 8h à 18h du lundi au vendredi. (code erreur : '+error.response.data.message+')'
                });
                reject(error);
            });
        });
    },

    sendCommandeLetreco({commit
    }, commandeId) {
        return new Promise((resolve, reject) => {
            window.axios.post('/api/letreco/send', {commande_id: commandeId}).then(response => {
                resolve(response);
            }).catch(error => {
                Vue.toasted.global.expedium_error({
                    message : 'Une erreur est survenue. Si le problème persiste veuillez contacter nos services de 8h à 18h du lundi au vendredi. (code erreur : '+error.response.data.message+')'
                });
                reject(error);
            });
        });
    },

    deleteDocument({commit
    }, documentId) {
        return new Promise((resolve, reject) => {
            window.axios.delete("/api/commandeDocument/"+documentId).then(response => {
                resolve(response);
            }).catch(error => {
                Vue.toasted.global.expedium_error({
                    message : 'Une erreur est survenue. Si le problème persiste veuillez contacter nos services de 8h à 18h du lundi au vendredi. (code erreur : '+error.response.data.message+')'
                });
                reject(error);
            });
        });
    },

};

const mutations = {
    setCategorie(state, categ) {
        categ.categorie_has_groupes.forEach(group => {
            group.groupe.value = '';
            group.groupe.commentaire = '';
            if (group.groupe.type_champ == 2) {
                group.groupe.obligatoire = false;
            } else {
                group.groupe.obligatoire = true;
            }
            group.groupe.probleme = false;
            group.groupe.groupe_options.forEach(option => {
                option.selected = false;
                option.commentaire = '';
            });
        });
        state.categorie = categ;
    },
    setFileUploading(state, fileUploading) {
        state.fileUploading = fileUploading
    },
    setLastOrder(state, lastOrder) {
        state.lastOrder = lastOrder
    },
    setPercentUploaded(state, percentUploaded) {
        state.percentUploaded = percentUploaded
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
